// import decorateComponentWithProps from 'decorate-component-with-props'
import decorateComponentWithProps from 'decorate-component-with-props'
import { EditorState } from 'draft-js'
import { getEntityRange, getSelectionEntity } from 'draftjs-utils'
import { ENTITY_TYPE } from '@disco/constants/content-editor'
import { getCurrentEntity } from '@disco/content-editor/editor-utils'
import MergeTag from '../custom-blocks/merge-tag'

function mergeTagStrategy(
  contentBlock: Record<string, any>,
  callback: (...args: Array<any>) => any,
  contentState: Record<string, any>,
) {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity()
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === ENTITY_TYPE.MERGE_TAG
    )
  }, callback)
}

export default (): Record<string, any> => {
  const store = {
    getEditorRef: undefined,
  }
  return {
    initialize: ({
      getEditorRef,
    }: {
      getEditorRef: (...args: Array<any>) => any
    }) => {
      store.getEditorRef = getEditorRef
    },
    handleBeforeInput: (chars: string, editorState: EditorState) => {
      const entity = getCurrentEntity(editorState)
      const selection = editorState.getSelection()

      // entities shouldn't be edited or altered in any way
      if (entity && entity.getType() === ENTITY_TYPE.MERGE_TAG) {
        const entityKey = getSelectionEntity(editorState)
        const { start, end } = getEntityRange(editorState, entityKey)
        const focusOffset = selection.getFocusOffset()
        if (start === focusOffset || end === focusOffset) return 'not-handled'
        return 'handled'
      }

      return 'not-handled'
    },
    decorators: [
      {
        strategy: mergeTagStrategy,
        component: decorateComponentWithProps(MergeTag, {
          store,
        }),
        editable: false,
      },
    ],
  }
}
